<template>
  <div class="email-input-container">
    <v-text-field
      type="email"
      :label="label"
      :rules="requireEmail ? [rules.required, rules.email] : [rules.email]"
      :placeholder="placeholder || 'Enter an email address'"
      v-model="emailValue"
      @change="handleChange"
      density="compact"
      autocomplete="off"
      :disabled="disabled"
      :error-messages="errorMessages"
      hide-details="auto"
    >
      <template v-if="!emailValue && requireEmail == true" v-slot:append-inner>
        <div class="checkbox-wrapper d-flex align-center">
          <v-btn
            icon
            variant="text"
            density="compact"
            @click="toggleRefusedEmail"
            :disabled="disabled"
            class="mr-1"
          >
            <v-icon
              :color="disabled ? 'grey' : 'primary'"
              :icon="
                isRefused
                  ? 'mdi-checkbox-marked-outline'
                  : 'mdi-checkbox-blank-outline'
              "
            />
          </v-btn>
          <span
            class="refused-label"
            @click="toggleRefusedEmail"
            :class="{ 'text-disabled': disabled }"
          >
            Refused to Give
          </span>
        </div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'VuetifyEmailInput',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    refusedEmail: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      default: 'Email',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    requireEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emailValue: this.modelValue,
      // Start from the saved state so a refused contact shows as refused
      isRefused: !!this.refusedEmail,
      rules: {
        required: (value) =>
          !value && this.requireEmail && !this.isRefused ? 'Required.' : true,
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return this.isRefused
            ? true
            : pattern.test(value) || 'Invalid e-mail.';
        },
      },
    };
  },
  computed: {
    errorMessages() {
      if (this.requireEmail && !this.emailValue && !this.isRefused) {
        return ['Must enter email or Refused to give'];
      }
      return [];
    },
  },
  watch: {
    modelValue(newVal) {
      this.emailValue = newVal;
    },
    refusedEmail(newVal) {
      this.isRefused = newVal;
    },
  },
  methods: {
    handleChange() {
      this.$emit('update:modelValue', this.emailValue);
      // Change is already fired and will bubble, we dont need a second
      // this.$emit('change', this.emailValue);
    },
    toggleRefusedEmail() {
      if (!this.disabled) {
        this.isRefused = !this.isRefused;
        this.$emit('update:refused-email', this.isRefused);
      }
    },
  },
};
</script>

<style scoped>
.email-input-container {
  position: relative;
}

.checkbox-wrapper {
  white-space: nowrap;
  align-items: center;
}

.refused-label {
  font-size: 12px;
  cursor: pointer;
  user-select: none;
  margin-left: 4px;
}

.refused-label:hover {
  text-decoration: underline;
}

.refused-label.text-disabled {
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
  text-decoration: none;
}
</style>
